import React, { useState } from "react";
import T from "prop-types";
import { Row, Col } from "react-bootstrap";
import moment from "moment";
import { withPolling } from "MODULES/shared/decorators";
import { Stat } from "MODULES/shared/components";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import PerLocationModal from "MODULES/PurchasesDashboard/Components/PerLocationModal";
import numeral from "numeral";
import {
  PurchasesCount,
  PurchaseLinesCount,
  TotalRealized,
  TotalRealizedPercent,
  LotPurchasesSum,
  purchasesSum,
  SrpTotal
} from "./Stats";

function MonthlyStats({ currentUser, selectedDate, purchasesData }) {
  const date = moment(selectedDate).format("MMM YYYY");
  const [open, setOpen] = useState(false);

  return [
    <Row>
      <Col md={4} lg={2}>
        <PurchasesCount dateLabel={date} data={purchasesData} />
      </Col>
      <Col md={4} lg={2}>
        <PurchaseLinesCount dateLabel={date} data={purchasesData} />
      </Col>
      <Col md={4} lg={3}>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            textAlign: "center"
          }}
        >
          <Stat
            label={[
              "$ Purchases Total",
              currentUser.locations.length > 1 && (
                <i
                  className="fa fa-info-circle fa-sm pointer"
                  onClick={() => setOpen(true)}
                  style={{ marginLeft: "5px" }}
                />
              )
            ].filter(f => f)}
            value={numeral(purchasesSum(purchasesData)).format("($0,0)")}
          />
        </div>
      </Col>
      <Col md={4} lg={2}>
        <SrpTotal data={purchasesData} />
      </Col>
      <Col md={4} lg={2}>
        <TotalRealized dateLabel={date} data={purchasesData} />
      </Col>
      <Col md={4} lg={1}>
        <TotalRealizedPercent dateLabel={date} data={purchasesData} />
      </Col>
      <PerLocationModal
        purchasesData={purchasesData}
        open={open}
        setOpen={setOpen}
      />
    </Row>,
    <Row>
      <Col lgOffset={2} mdOffset={5} md={4} lg={2}>
        <Stat
          label={`$ Purchased For Stock`}
          value={numeral(
            purchasesData.purchased_for_stock_or_repair_assist
          ).format("($0,0)")}
        />
      </Col>
      <Col md={4} lg={2}>
        <Stat
          label={`$ Purchased For Repair`}
          value={numeral(purchasesData.purchased_for_repair_total).format(
            "($0,0)"
          )}
        />
      </Col>
      <Col md={4} lg={2}>
        <Stat
          label={`$ Purchased For Sale`}
          value={numeral(purchasesData.purchased_for_sale_total).format(
            "($0,0)"
          )}
        />
      </Col>
      <Col md={4} lg={2}>
        <LotPurchasesSum dateLabel={date} data={purchasesData} />
      </Col>
    </Row>
  ];
}

MonthlyStats.propTypes = {
  selectedDate: T.string,
  purchasesData: T.arrayOf(T.shape({}))
};

export default withCurrentUser(withPolling(MonthlyStats));



// WEBPACK FOOTER //
// ./app/modules/PurchasesDashboard/Components/MonthlyStats.jsx